import {InaccessibleInfo} from 'auth/RequestAccess';
import {ManagedModelType, ManagedModelTypes} from 'models/ManagedModelDefinitions';
import {modelInaccessible} from 'models/ManagedModelsReduxActions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import {fetchRequestFulfillments} from 'requests/fulfillments/FulfillmentReduxActions';
import * as RequestTaskSchemaReduxActions from 'requests/schemas/RequestTaskSchemaReduxActions';
import * as AssaySchemaActions from 'results/AssaySchemaActions';

import {RequestFulfillmentModelSelector} from './RequestFulfillmentModelSelector';

export default class RequestFulfillmentsModelManager extends ModelManager<ManagedModelType.HYDRATED_FULFILLMENT_BY_ID> {
  constructor() {
    super(ManagedModelType.HYDRATED_FULFILLMENT_BY_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    await Promise.all([
      getStore().dispatch(fetchRequestFulfillments(keys)),

      // Fetches requestTaskSchemasById
      getStore().dispatch(RequestTaskSchemaReduxActions.fetchAll()),

      // Fetches request schemas
      AssaySchemaActions.fetchAllAssaySchemas(),
    ]);
    const inaccessibleInfoById: {[storableId: string]: InaccessibleInfo} = {};
    const inaccessibleFulfillmentIds = keys.filter((key) => this.getModel(key) == null);
    inaccessibleFulfillmentIds.forEach((id) => {
      inaccessibleInfoById[id] = {invalidId: id};
    });
    getStore().dispatch(modelInaccessible(ManagedModelType.HYDRATED_FULFILLMENT_BY_ID, inaccessibleInfoById));
  }

  getModel(modelKey: string): ManagedModelTypes[ManagedModelType.HYDRATED_FULFILLMENT_BY_ID] | null {
    return new RequestFulfillmentModelSelector(getStore().getState()).getModel(modelKey);
  }
}
